// removed by extract-text-webpack-plugin
module.exports = {"terms-title":"terms-title","save-btn":"save-btn","footer-section":"footer-section","control":"control","checkmark":"checkmark"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/RegistrationAgreement/RegistrationAgreement.scss
// module id = FNRm
// module chunks = 0